// OSIS Zoom Integration
import React, { useState } from 'react';
import {
  Video,
  Users,
  Calendar,
  Clock,
  Phone,
  Monitor,
  Settings,
  CheckCircle,
  AlertCircle,
  Play,
  Pause,
  Mic,
  MicOff,
  Camera,
  CameraOff,
  Share,
  MessageSquare,
  Activity
} from 'lucide-react';

const ZoomIntegration = () => {
  const [connectionStatus] = useState('connected');
  const [currentMeeting, setCurrentMeeting] = useState({
    active: true,
    title: 'Prezentare Proiect Casa Ionescu',
    participants: 4,
    duration: '01:23:45',
    meetingId: '123-456-789'
  });

  const [upcomingMeetings] = useState([
    {
      id: 1,
      title: 'Măsurători Casa Cluj',
      time: '16:00 - 17:00',
      date: '2025-01-16',
      participants: 3,
      type: 'client'
    },
    {
      id: 2,
      title: 'Meeting Echipă Săptămânal',
      time: '09:00 - 10:00',
      date: '2025-01-17',
      participants: 8,
      type: 'internal'
    },
    {
      id: 3,
      title: 'Prezentare Furnizor epoxidic',
      time: '14:30 - 15:30',
      date: '2025-01-17',
      participants: 5,
      type: 'supplier'
    }
  ]);

  const [stats] = useState({
    meetingsToday: 3,
    totalMinutes: 245,
    participants: 12,
    recordings: 8
  });

  const getMeetingTypeColor = (type) => {
    switch (type) {
      case 'client': return 'bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-300';
      case 'internal': return 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-300';
      case 'supplier': return 'bg-purple-100 text-purple-800 dark:bg-purple-900/30 dark:text-purple-300';
      default: return 'bg-gray-100 text-gray-800 dark:bg-gray-900/30 dark:text-gray-300';
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="mb-8">
          <div className="flex items-center mb-4">
            <Video className="w-8 h-8 text-blue-600 mr-3" />
            <div>
              <h1 className="text-3xl font-bold text-gray-900 dark:text-white">
                Zoom Integration
              </h1>
              <p className="text-gray-600 dark:text-gray-400 mt-1">
                Gestionează meeting-urile și videoconferințele OSIS
              </p>
            </div>
          </div>
        </div>

        {/* Connection Status */}
        <div className="bg-gradient-to-r from-blue-50 to-purple-50 dark:from-blue-900/20 dark:to-purple-900/20 rounded-xl border border-blue-200 dark:border-blue-800 p-6 mb-8">
          <div className="flex items-center justify-between">
            <div className="flex items-center">
              <CheckCircle className="w-6 h-6 text-green-600 mr-3" />
              <div>
                <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
                  Conectat la Zoom
                </h3>
                <p className="text-sm text-gray-600 dark:text-gray-400">
                  Account: osis@zoom.com • Plan: Pro • Status: Activ
                </p>
              </div>
            </div>
            <button className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg transition-colors">
              Configurează
            </button>
          </div>
        </div>

        {/* Stats Cards */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8">
          <div className="bg-white dark:bg-gray-800 rounded-xl shadow-soft border border-gray-200 dark:border-gray-700 p-6">
            <div className="flex items-center">
              <div className="flex items-center justify-center w-12 h-12 bg-blue-100 dark:bg-blue-900 rounded-xl">
                <Calendar className="w-6 h-6 text-blue-600" />
              </div>
              <div className="ml-4">
                <p className="text-sm font-medium text-gray-500 dark:text-gray-400">Astăzi</p>
                <p className="text-2xl font-bold text-gray-900 dark:text-white">{stats.meetingsToday}</p>
                <p className="text-xs text-gray-400">meeting-uri</p>
              </div>
            </div>
          </div>

          <div className="bg-white dark:bg-gray-800 rounded-xl shadow-soft border border-gray-200 dark:border-gray-700 p-6">
            <div className="flex items-center">
              <div className="flex items-center justify-center w-12 h-12 bg-green-100 dark:bg-green-900 rounded-xl">
                <Clock className="w-6 h-6 text-green-600" />
              </div>
              <div className="ml-4">
                <p className="text-sm font-medium text-gray-500 dark:text-gray-400">Minute Total</p>
                <p className="text-2xl font-bold text-gray-900 dark:text-white">{stats.totalMinutes}</p>
                <p className="text-xs text-gray-400">această lună</p>
              </div>
            </div>
          </div>

          <div className="bg-white dark:bg-gray-800 rounded-xl shadow-soft border border-gray-200 dark:border-gray-700 p-6">
            <div className="flex items-center">
              <div className="flex items-center justify-center w-12 h-12 bg-purple-100 dark:bg-purple-900 rounded-xl">
                <Users className="w-6 h-6 text-purple-600" />
              </div>
              <div className="ml-4">
                <p className="text-sm font-medium text-gray-500 dark:text-gray-400">Participanți</p>
                <p className="text-2xl font-bold text-gray-900 dark:text-white">{stats.participants}</p>
                <p className="text-xs text-gray-400">săptămâna aceasta</p>
              </div>
            </div>
          </div>

          <div className="bg-white dark:bg-gray-800 rounded-xl shadow-soft border border-gray-200 dark:border-gray-700 p-6">
            <div className="flex items-center">
              <div className="flex items-center justify-center w-12 h-12 bg-red-100 dark:bg-red-900 rounded-xl">
                <Monitor className="w-6 h-6 text-red-600" />
              </div>
              <div className="ml-4">
                <p className="text-sm font-medium text-gray-500 dark:text-gray-400">Înregistrări</p>
                <p className="text-2xl font-bold text-gray-900 dark:text-white">{stats.recordings}</p>
                <p className="text-xs text-gray-400">disponibile</p>
              </div>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {/* Current Meeting */}
          <div className="lg:col-span-2">
            {currentMeeting.active && (
              <div className="bg-white dark:bg-gray-800 rounded-xl shadow-soft border border-gray-200 dark:border-gray-700 p-6 mb-6">
                <div className="flex items-center justify-between mb-4">
                  <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
                    Meeting Activ
                  </h3>
                  <div className="flex items-center">
                    <div className="w-3 h-3 bg-red-500 rounded-full mr-2 animate-pulse"></div>
                    <span className="text-sm text-red-600 font-medium">LIVE</span>
                  </div>
                </div>

                <div className="bg-gray-900 rounded-lg p-6 mb-4">
                  <div className="flex items-center justify-between mb-4">
                    <div>
                      <h4 className="text-white font-semibold">{currentMeeting.title}</h4>
                      <p className="text-gray-300 text-sm">Meeting ID: {currentMeeting.meetingId}</p>
                    </div>
                    <div className="text-right text-white">
                      <p className="font-mono text-lg">{currentMeeting.duration}</p>
                      <p className="text-sm text-gray-300">{currentMeeting.participants} participanți</p>
                    </div>
                  </div>

                  <div className="flex items-center justify-center space-x-4">
                    <button className="flex items-center px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded-lg transition-colors">
                      <MicOff className="w-4 h-4 mr-2" />
                      Mute
                    </button>
                    <button className="flex items-center px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg transition-colors">
                      <Camera className="w-4 h-4 mr-2" />
                      Video
                    </button>
                    <button className="flex items-center px-4 py-2 bg-green-600 hover:bg-green-700 text-white rounded-lg transition-colors">
                      <Share className="w-4 h-4 mr-2" />
                      Share
                    </button>
                    <button className="flex items-center px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded-lg transition-colors">
                      <Phone className="w-4 h-4 mr-2" />
                      Leave
                    </button>
                  </div>
                </div>
              </div>
            )}

            {/* Quick Actions */}
            <div className="bg-white dark:bg-gray-800 rounded-xl shadow-soft border border-gray-200 dark:border-gray-700 p-6">
              <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">
                Acțiuni Rapide
              </h3>
              <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
                <button className="flex flex-col items-center p-4 bg-blue-50 dark:bg-blue-900/30 rounded-xl hover:bg-blue-100 dark:hover:bg-blue-900/50 transition-colors">
                  <Video className="w-6 h-6 text-blue-600 mb-2" />
                  <span className="text-sm font-medium text-blue-700 dark:text-blue-300">Start Meeting</span>
                </button>
                <button className="flex flex-col items-center p-4 bg-green-50 dark:bg-green-900/30 rounded-xl hover:bg-green-100 dark:hover:bg-green-900/50 transition-colors">
                  <Calendar className="w-6 h-6 text-green-600 mb-2" />
                  <span className="text-sm font-medium text-green-700 dark:text-green-300">Schedule</span>
                </button>
                <button className="flex flex-col items-center p-4 bg-purple-50 dark:bg-purple-900/30 rounded-xl hover:bg-purple-100 dark:hover:bg-purple-900/50 transition-colors">
                  <Monitor className="w-6 h-6 text-purple-600 mb-2" />
                  <span className="text-sm font-medium text-purple-700 dark:text-purple-300">Recordings</span>
                </button>
              </div>
            </div>
          </div>

          {/* Upcoming Meetings */}
          <div>
            <div className="bg-white dark:bg-gray-800 rounded-xl shadow-soft border border-gray-200 dark:border-gray-700 p-6">
              <div className="flex items-center justify-between mb-4">
                <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
                  Meeting-uri Programate
                </h3>
                <Calendar className="w-5 h-5 text-gray-400" />
              </div>

              <div className="space-y-4">
                {upcomingMeetings.map((meeting) => (
                  <div key={meeting.id} className="p-4 bg-gray-50 dark:bg-gray-700 rounded-lg">
                    <div className="flex items-center justify-between mb-2">
                      <h4 className="font-medium text-gray-900 dark:text-white truncate">
                        {meeting.title}
                      </h4>
                      <span className={`px-2 py-1 rounded-full text-xs font-medium ${getMeetingTypeColor(meeting.type)}`}>
                        {meeting.type === 'client' ? 'Client' : 
                         meeting.type === 'internal' ? 'Intern' : 'Furnizor'}
                      </span>
                    </div>
                    <div className="flex items-center justify-between text-sm text-gray-600 dark:text-gray-400">
                      <div className="flex items-center">
                        <Clock className="w-4 h-4 mr-1" />
                        <span>{meeting.time}</span>
                      </div>
                      <div className="flex items-center">
                        <Users className="w-4 h-4 mr-1" />
                        <span>{meeting.participants}</span>
                      </div>
                    </div>
                    <div className="mt-2">
                      <button className="text-blue-600 hover:text-blue-700 text-sm font-medium">
                        Join Meeting
                      </button>
                    </div>
                  </div>
                ))}
              </div>

              <button className="w-full mt-4 px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg transition-colors">
                Vezi Toate Meeting-urile
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ZoomIntegration;
